import { USER_ROLE, USER_STATUS } from 'shared/common/enums'
import { isObject } from './generics'
import { isUser } from './graphql-types'

export const isAdminOrGuide = (user: any): boolean =>
  user?.role === USER_ROLE.admin || user?.role === USER_ROLE.guide

export const isContributor = (user: any): boolean =>
  user?.role === USER_ROLE.contributor

export const isTaskOwner = (user: any): boolean =>
  user?.role === USER_ROLE.taskOwner

export const isSuperAdmin = (user: any): boolean =>
  isUser(user) && user?.role === USER_ROLE.superAdmin

export const isAdmin = (user: any): boolean =>
  isObject(user) && user?.role === USER_ROLE.admin

export const isManager = (user: any): boolean =>
  isObject(user) && user?.role === USER_ROLE.manager

export const isAdminOrManager = (user: any): boolean =>
  isAdmin(user) || isManager(user)

export const isObserver = (user: any): boolean =>
  isUser(user) && user?.role === USER_ROLE.observer

export const isGuide = (user: any): boolean =>
  isUser(user) && user?.role === USER_ROLE.guide

export const isActiveViaSso = (user: any): boolean =>
  user.status === USER_STATUS.activeViaSso
